"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glCore = require("@capture/gl-core");

class ShapeBaseGLFilter extends _glCore.GLFilter {
  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.screenSize = gl.getUniformLocation(program, 'screenSize');
    return uniformLocations;
  }

  onViewSizeChanged(gl, width, height) {
    gl.uniform2f(this.uniformLocations.screenSize, 1.0 / width, 1.0 / height);
  }

}

exports.default = ShapeBaseGLFilter;